import { COOKIES } from "constants/cookies";
import { getCookie } from "./cookies";

const PATH_ROUTES_TO_INTERCEPT_REQUEST = [
  "/api/v1/cart",
  "/api/v1/session_info",
  "/api/v1/security_verifications",
  "/api/v1/brand_alerts",
  "/api/v1/rating",
  "/api/v1/checkout",
  "/api/v1/payment_methods",
  "/api/v1/orders",
  "/api/v1/zendesk/authenticate"
];

export const makeAuthorizationToken = (config) => {
  const token = getCookie(COOKIES.TOKEN);
  const hasAuthorizationHeader = !!config.headers.Authorization;
  if (!!token && !hasAuthorizationHeader) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

export const addXSessionHeader = (config) => {
  const xSession = getCookie(COOKIES.X_SESSION);
  if (xSession) {
    config.headers["X-Session"] = xSession;
  }
  return config;
};

export const setupInterceptors = (instance) => {
  // Add X-Session header for all /api/v1 requests
  instance.interceptors.request.use((config) => {
    if (config.url && config.url.includes("/api/v1")) {
      return addXSessionHeader(config);
    }
    return config;
  });

  // Add Authorization header for specific routes
  instance.interceptors.request.use((config) => {
    const shouldInterceptAuthorization = PATH_ROUTES_TO_INTERCEPT_REQUEST.some(
      (value) => config.url.includes(value)
    );
    if (shouldInterceptAuthorization) return makeAuthorizationToken(config);

    return config;
  });
};
